// components
import CommonForm from "../Common/CommonForm";
import BaseApi from "../../utils/BaseApi";
import CommonActionModal from "../Common/CommonActionModal";

// icons
import AssignmentIcon from "@mui/icons-material/Assignment";
import ImportExportIcon from "@mui/icons-material/ImportExport";

class ApplicantUploadModal extends CommonActionModal {
    async componentDidMount() {
        let formFields = await this.retrieveFields();
        this.setState({
            buttonIcon: ImportExportIcon,
            buttonLabel: 'Импортировать',
            buttonColor: 'primary',
            modalLabel: 'Добавление соискателя',
            modalIcon: AssignmentIcon,
            mainComponent: CommonForm,
            mainComponentProps: {
                fields: formFields,
                processForm: this.processForm.bind(this),
            },
            ready: true,
        })
    }

    async retrieveFields() {
        return [
            {
                'name': 'upload',
                'label': 'Файл',
                'xs': 12,
                'sm': null,
                'md': null,
                'lg': null,
                'xl': null,
                'required': true,
                'default': null,
                'type': 'file',
            },
            {
                type: 'submit',
                label: 'Добавить'
            }
        ]
    }

    async processForm(form) {
        let formData = form.state.formData;
        let fileInput = form.state.formObject.upload;
        let upload = fileInput.files[0];
        if (upload) {
            formData.append('upload', upload);
        }
        const url = `applicant/upload/`;
        const api = new BaseApi();
        let response = await api.post(
            url,
            formData
        );
        if (response.status === 200) {
            if (this.props.callBack){
                await this.props.callBack()
            }
            this.setModalOpenFalse();
        }
    }
}

export default ApplicantUploadModal